import { ConversationItemTypeEnum, MessageOutboundState } from "@/types/ConversationTypes";
import { AuthorType } from "@/types/UserTypes";
export const outboundMessage = {
    id: Date.now() * -1,
    type: ConversationItemTypeEnum.MESSAGE,
    authorType: AuthorType.CUSTOMER,
    author: {
        name: 'You'
    },
    status: MessageOutboundState.DRAFT,
    body: null,
    ts: Date.now() / 1000
};
